/**
 * Search value by Table value
 */
export default (query: string, data: object[]) => {

    function result(field:{[key: string]: any}) {
        for (const key in field) {
            if (field.hasOwnProperty(key)) {
                const val = field[key];

                if(!val) {
                    continue;
                }

                if(typeof val === 'object') {
                    if (result(val)) {
                        return true;
                    }

                    continue;
                }

                if (val.toString().toLowerCase().includes(query.toLowerCase())) {
                    return true;
                }
            }
        }

        return false;
    }

    function search(searchData:object[]) {
        return searchData.filter((item: object) => result(item))
    }
    
    return query ? search(data) : null;
};